const trimTrailingSlashes = (value: string) => value.replace(/\/+$/, '');
const trimLeadingSlashes = (value: string) => value.replace(/^\/+/, '');

const getClientProtocol = () =>
  typeof window !== 'undefined' && window.location?.protocol
    ? window.location.protocol
    : 'http:';

export const resolveClientUrl = (rawUrl?: string) => {
  const trimmedUrl = rawUrl?.trim() || '';

  if (!trimmedUrl) {
    return '';
  }

  if (/^https?:\/\//i.test(trimmedUrl)) {
    return trimTrailingSlashes(trimmedUrl);
  }

  return trimTrailingSlashes(`${getClientProtocol()}//${trimmedUrl}`);
};

export const resolveApiBaseUrl = (rawUrl?: string) => resolveClientUrl(rawUrl);

export const appendPathToClientUrl = (baseUrl?: string, path?: string) => {
  const resolvedBaseUrl = resolveClientUrl(baseUrl);
  const trimmedPath = path?.trim() || '';

  if (!resolvedBaseUrl) {
    return '';
  }

  if (!trimmedPath) {
    return resolvedBaseUrl;
  }

  return `${resolvedBaseUrl}/${trimLeadingSlashes(trimmedPath)}`;
};
